import { render } from "./boolRound.vue?vue&type=template&id=25af5e3a"
import script from "./boolRound.vue?vue&type=script&lang=js"
export * from "./boolRound.vue?vue&type=script&lang=js"

import "./boolRound.vue?vue&type=style&index=0&id=25af5e3a&lang=css"

import exportComponent from "/builds/oleksandr.makhovskyi/admin-template/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__